// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"cc90a337","82":"06013f5d","101":"f5e5bc0a","288":"2814c1d0","419":"ebae760b","766":"870b096b","845":"848e441a","849":"630507da","879":"31d58b10"}[chunkId] + ".chunk.js";
};